// Google Tag Manager integration - Web Container (Client-Side)
export const GTM_WEB_ID = import.meta.env.VITE_GTM_WEB_ID;
export const GTM_ENABLED = import.meta.env.VITE_GTM_ENABLED === 'true';

/**
 * Set default consent state (denied) before GTM loads.
 * This ensures GTM Consent Mode tags wait for explicit consent.
 */
export const setDefaultConsent = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'denied',
    wait_for_update: 500
  });
};

let gtmInitialized = false;

/**
 * Initialize GTM Web Container - call this once in your app entry point
 */
export const initGTM = () => {
  if (!GTM_ENABLED || !GTM_WEB_ID) {
    console.log('GTM disabled or Web ID not configured');
    return;
  }

  if (gtmInitialized) {
    return;
  }
  gtmInitialized = true;

  // Grant consent since user accepted cookies
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('consent', 'update', {
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted',
    analytics_storage: 'granted'
  });

  // Add GTM script to head
  const script = document.createElement('script');
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_WEB_ID}');
  `;
  document.head.appendChild(script);

  // Add GTM noscript to body
  const noscript = document.createElement('noscript');
  noscript.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_WEB_ID}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `;
  document.body.insertBefore(noscript, document.body.firstChild);

  // Push consent_granted event so GTM tags can trigger on it
  // (the built-in "All Pages" trigger fires only once during GTM init)
  window.dataLayer.push({ event: 'cookie_consent_granted' });

  console.log('GTM Web Container initialized:', GTM_WEB_ID);
};

/**
 * Push event to dataLayer
 */
export const trackEvent = (eventName, eventData = {}) => {
  if (!GTM_ENABLED) {
    console.log('GTM disabled - would track:', eventName, eventData);
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...eventData
  });

  console.log('GTM Event:', eventName, eventData);
};

/**
 * Track page view
 */
export const trackPageView = (pagePath, pageTitle) => {
  trackEvent('page_view', {
    page_path: pagePath,
    page_title: pageTitle
  });
};
